import set from "lodash/set";
import type { Action } from "../../actions/types";

export type StoreState = {
  [key: string]: any;
};

export const initialState: StoreState = {};

export function reducer(state: StoreState = initialState, action: Action) {
  switch (action.type) {
    case "SET_USER_INPUT":
      const { path, value } = action;

      return set({ ...state }, path, value);

    default:
      return state;
  }
}
